export default "__VITE_ASSET__C2VmIz5j__"